import { render, staticRenderFns } from "./payment-modal.vue?vue&type=template&id=646e2726"
import script from "./payment-modal.vue?vue&type=script&lang=js"
export * from "./payment-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports